import { Heading, Text } from '@cinch-labs/design-system'
import { StoryblokImage } from '@cinch-nx/data-storyblok'

import {
  Carousel,
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
} from '../carousel'
import styles from './carousel-with-heading-and-text.module.css'

export interface CarouselWithHeadingAndTextProps {
  name: string
  carouselSlides: SlideProps[]
}

export interface SlideProps {
  heading: string
  body: string
  image: StoryblokImage
}

export const CarouselWithHeadingAndText: React.FC<
  CarouselWithHeadingAndTextProps
> = ({ name, carouselSlides }) => {
  const carouselSettings = {
    name: name,
    ariaLabels: {
      previous: 'Go to previous slide',
      next: 'Go to next slide',
    },
    swiperSettings: {
      spaceBetween: 78,
      slidesPerView: 1,
    },
  }

  return (
    <div className={styles.carouselWrapper}>
      <Carousel
        name={carouselSettings.name}
        swiperSettings={carouselSettings.swiperSettings}
        customClassNames={{
          carousel: styles.carousel,
        }}
      >
        {carouselSlides.map((slide, idx) => (
          <CarouselSlide key={idx}>
            <div className={styles.imageWrapper}>
              <img
                src={slide.image.filename}
                alt={slide.image.alt ?? undefined}
                className={styles.image}
              />
            </div>
          </CarouselSlide>
        ))}
      </Carousel>
      <CarouselControls customClassNames={styles.carouselControls}>
        <CarouselPagination name={carouselSettings.name} />
        <CarouselNavigation
          name={carouselSettings.name}
          ariaLabels={carouselSettings.ariaLabels}
          customClassNames={{
            prevButton: styles.carouselNavButton,
            nextButton: styles.carouselNavButton,
          }}
        />
      </CarouselControls>
      <Carousel
        name={carouselSettings.name}
        swiperSettings={carouselSettings.swiperSettings}
        customClassNames={{
          carousel: styles.carousel,
        }}
      >
        {carouselSlides.map((slide, idx) => (
          <CarouselSlide key={idx}>
            <div className={styles.body}>
              <Heading className={styles.heading}>{slide.heading}</Heading>
              <Text className={styles.text}>{slide.body}</Text>
            </div>
          </CarouselSlide>
        ))}
      </Carousel>
    </div>
  )
}

export default CarouselWithHeadingAndText
